import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { Router } from '@angular/router';
import { CurriculumItemStandardsGrowth, CurriculumViewItem } from 'src/app/Elearning-Models';
import {MatTabsModule} from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-curriculum-view-details-dialog',
  templateUrl: './curriculum-view-details-dialog.component.html',
  styleUrls: ['./curriculum-view-details-dialog.component.scss']
})
export class CurriculumViewDetailsDialogComponent implements OnInit {
  valueUpdated = new EventEmitter<any>();
  title: string;
  dataService: CurriculumService;
  public curriculumViewDetail: CurriculumViewItem;
  public isTeacher = false;
  public studentName = '';

  curriculumItemStandards: CurriculumItemStandardsGrowth[];
  
  // = 

  constructor(
    public dialogRef: MatDialogRef<CurriculumViewDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private serviceFactory: IServiceFactory,
    private router: Router) {
      this.curriculumViewDetail = data.curriculumData;
      this.curriculumItemStandards = this.curriculumViewDetail.StandardsGrowth;
      this.title = data.title;
      this.studentName = data.studentName;
      this.isTeacher = data.IsTeacher;
      this.dataService = serviceFactory.getCurriculumService();
    }

  ngOnInit(): void {
    
  }

  onCancel = () => {
    this.valueUpdated.emit(false);
    this.dialogRef.close();
  }
  redirectToViewWorkFromAttempt = (data): void => {
    this.onCancel();
    this.router.navigate(['ELearning/ViewWork'], { queryParams: { AssignmentID: data.AssignmentID, AttemptID: data.AttemptID,
      AssignmentName: this.curriculumViewDetail.LessonName, StudentName: this.studentName }});
  }

  redirectToViewWorkFromDiagnostic = (data): void => {
    this.onCancel();
    this.router.navigate(['ELearning/ViewWork'], { queryParams: { AssignmentID: data.AssignmentID, AttemptID: data.AttemptID,
      AssignmentName: data.Name, StudentName: this.studentName }});
  }

  checkForRedGrade(grade: string){
    var result = grade && parseInt(grade) < 70;
    return result;
  }

  checkForGreenGrade(grade: string){
    var result = grade && parseInt(grade) >= 70;
    return result;
  }

}
